//UPDATE DETAIL
export const MANAGER_UPDATE_DETAIL_REQUEST = 'MANAGER_UPDATE_DETAIL_REQUEST';
export const MANAGER_UPDATE_DETAIL_SUCCESS = 'MANAGER_UPDATE_DETAIL_SUCCESS';
export const MANAGER_UPDATE_DETAIL_FAIL = 'MANAGER_UPDATE_DETAIL_FAIL';

//CHANGE PASSWORD
export const MANAGER_CHANGE_PASSWORD_REQUEST = 'MANAGER_CHANGE_PASSWORD_REQUEST';
export const MANAGER_CHANGE_PASSWORD_SUCCESS = 'MANAGER_CHANGE_PASSWORD_SUCCESS';
export const MANAGER_CHANGE_PASSWORD_FAIL = 'MANAGER_CHANGE_PASSWORD_FAIL';

//UPDATE IMAGE
export const MANAGER_UPDATE_IMAGE_REQUEST = 'MANAGER_UPDATE_IMAGE_REQUEST';
export const MANAGER_UPDATE_IMAGE_SUCCESS = 'MANAGER_UPDATE_IMAGE_SUCCESS';
export const MANAGER_UPDATE_IMAGE_FAIL = 'MANAGER_UPDATE_IMAGE_FAIL';

//RESEND_EMAIL
// export const ADMIN_RESEND_EMAIL_REQUEST = 'ADMIN_RESEND_EMAIL_REQUEST';
// export const ADMIN_RESEND_EMAIL_SUCCESS = 'ADMIN_RESEND_EMAIL_SUCCESS';
// export const ADMIN_RESEND_EMAIL_FAIL = 'ADMIN_CHANGE_PASSWORD_FAIL';